import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Settings, Users, Link2, MessagesSquare } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { AdminSettingCard, SlackChannelsCard } from '../components/admin';
import { isGustoEnvEnabled } from '../hooks';

const AdminSettings: React.FC = () => {
  const { t } = useTranslation('admin');
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const gustoEnvEnabled = isGustoEnvEnabled();

  useEffect(() => {
    // Refresh user data when component mounts to ensure we have latest photoURL
    refreshUser();
  }, [refreshUser]);

  if (!user) {
    return null;
  }

  return (
    <div className="container mx-auto py-8 px-4 max-w-6xl" data-testid="admin-settings-page">
      <div className="flex items-center gap-3 mb-6">
        <Settings className="h-8 w-8" />
        <h1 className="text-3xl font-bold" data-testid="admin-settings-title">{t('title')}</h1>
      </div>

      <div className="space-y-6">
        <AdminSettingCard
          icon={Users}
          title="Organizational Roles"
          description="Manage roles and admin privileges"
          onClick={() => navigate('/organizational-roles')}
          data-testid="admin-settings-card-org-roles"
        />

        {gustoEnvEnabled && (
          <AdminSettingCard
            icon={Link2}
            title={t('integrations.cardTitle')}
            description={t('integrations.cardDescription')}
            onClick={() => navigate('/settings/integrations')}
            data-testid="admin-settings-card-integrations"
          />
        )}

        <AdminSettingCard
          icon={MessagesSquare}
          title={t('slackChannels.kudosReview.title')}
          description={t('slackChannels.kudosReview.description')}
          onClick={() => navigate('/settings/slack-kudos-review')}
          data-testid="admin-settings-card-slack-kudos"
        />

        <SlackChannelsCard user={user} />
      </div>
    </div>
  );
};

export default AdminSettings;
